import { createFileRoute } from '@tanstack/react-router';
import { ProdutoresView } from '@/modules/agronomia/components/ProdutoresView';

// Tela 01 · Produtores — destino do pipe "Produtores" da seleção do módulo
// (desktop). No mobile a raiz /agronomia já cai direto aqui.
export const Route = createFileRoute('/_authed/agronomia_/produtores')({
  component: ProdutoresView,
});
